import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["isOpen", "onClose", "placement", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Modal } from "./chunk-UUGUEMMH.mjs";

// src/drawer.tsx
import { createContext } from "@chakra-ui/react-context";
import { useTheme } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext(),
  _createContext2 = _slicedToArray(_createContext, 2),
  DrawerContextProvider = _createContext2[0],
  useDrawerContext = _createContext2[1];
var placementMap = {
  start: {
    ltr: "left",
    rtl: "right"
  },
  end: {
    ltr: "right",
    rtl: "left"
  }
};
function getDrawerPlacement(placement, dir) {
  var _a, _b;
  if (!placement) return;
  return (_b = (_a = placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function Drawer(props) {
  var _a;
  var isOpen = props.isOpen,
    onClose = props.onClose,
    _props$placement = props.placement,
    placementProp = _props$placement === void 0 ? "right" : _props$placement,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
  var placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */jsx(DrawerContextProvider, {
    value: {
      placement: placement
    },
    children: /* @__PURE__ */jsx(Modal, _objectSpread(_objectSpread({
      isOpen: isOpen,
      onClose: onClose,
      styleConfig: drawerStyleConfig
    }, rest), {}, {
      children: children
    }))
  });
}
export { useDrawerContext, Drawer };